import { ISeriesApi } from 'lightweight-charts';
import { ChartTypeEnum } from '../../model/chart_type.enum';

export interface DataPoint {
  time: number;
  [key: string]: any;
}

export interface SeriesItem {
  id: string;
  type: string;
  chartType?: ChartTypeEnum;
  withMarkers?: boolean;
  seriesApi: ISeriesApi<any>;
  data: DataPoint[];
  color: string;
  label: string;
  options?: any;
}

export type SeriesState = Record<string, SeriesItem>;

export type SeriesAction =
  | { type: 'ADD'; payload: SeriesItem }
  | { type: 'REMOVE'; payload: { id: string } }
  | { type: 'UPDATE'; payload: { id: string; data: DataPoint[] } }
  | { type: 'APPEND_TICK'; payload: { id: string; tick: DataPoint } }
  | { type: 'RESET' };

export const seriesReducer = (state: SeriesState, action: SeriesAction): SeriesState => {
  switch (action.type) {
    case 'ADD':
      return { ...state, [action.payload.id]: action.payload };
    case 'REMOVE':
      // eslint-disable-next-line no-case-declarations, @typescript-eslint/no-unused-vars
      const { [action.payload.id]: _, ...rest } = state;
      return rest;
    case 'UPDATE':
      if (!state[action.payload.id]) return state;
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          data: action.payload.data,
        },
      };
    case 'APPEND_TICK': {
      const { id, tick } = action.payload;
      const serie = state[id];
      if (!serie) return state;
      return {
        ...state,
        [id]: {
          ...serie,
          data: [...serie.data, tick],
        },
      };
    }
    case 'RESET':
      return {};
    default:
      return state;
  }
};
